
const redirectToHttps = () => {

if (window.location.protocol === 'http:' && process.env.NODE_ENV !== 'development') {
  window.location.href = `https://${window.location.host}${window.location.pathname}`;
}
}

redirectToHttps();

export default redirectToHttps;